import classnames from "classnames";
import Icon from "components/Icons/Icon";
import { ChangeEvent } from "react";
import EmojiInput from "./EmojiPicker";

type InputGroupProps = {
  id: string;
  label?: string;
  placeholder: string;
  value?: string;
  error?: string;
  icon?: any;
  onChange?: ChangeEvent;
  type?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  dataTestid?: string;
  list?: Array<any>;
  onBlur?: any;
  prePend?: string;
  size?: string;
  specialField?: string;
  helperText?: string;
  withEmojiPicker?: boolean;
  emoji?: any;
  setEmoji?: any;
};

const InputGroup = ({
  id,
  label,
  placeholder,
  value,
  error,
  icon,
  onChange,
  type,
  autoFocus = false,
  dataTestid = "",
  list = [],
  disabled = false,
  onBlur,
  prePend,
  size = "regular",
  specialField,
  helperText,
  withEmojiPicker = false,
  emoji,
  setEmoji,
}: InputGroupProps) => {
  return (
    <div className={`input-container-wrapper ${size} ${specialField}`}>
      {label ? (
        <div className="label">
          <label htmlFor={id}>{label}</label>
          {helperText ? <caption>{helperText}</caption> : null}
        </div>
      ) : null}
      <div className={`input-container ${prePend || icon || withEmojiPicker ? "with-prepend" : null}`}>
        {!!icon ? (
          <div className="input-container-prepend">
            <Icon name={icon} />
          </div>
        ) : null}
        {!!prePend ? <div className="input-container-prepend">{prePend}</div> : null}
        {withEmojiPicker ? (
          <div className="">
            <EmojiInput emoji={emoji} setEmoji={setEmoji} />
          </div>
        ) : null}

        <input
          className={classnames("text-input", {
            "is-invalid": error,
          })}
          autoFocus={autoFocus}
          placeholder={placeholder}
          id={id}
          name={id}
          type={type}
          value={value}
          //@ts-ignore
          onChange={onChange}
          data-testid={dataTestid}
          list={list.length > 0 ? "listOptions" : ""}
          disabled={disabled}
          onBlur={onBlur}
        />
        {list.length > 0 ? (
          <datalist id="listOptions">
            {list.map((listItem) => (
              <option value={`${listItem.name}, ${listItem.name_suffix}`} key={listItem.id} />
            ))}
          </datalist>
        ) : (
          <></>
        )}
      </div>
      {!!error ? <div className="invalid-feedback error-feedback">{error}</div> : null}
    </div>
  );
};

export default InputGroup;
